const projects = [
  {
    id: 1,
    img: '/images/project-gallery/garage-front-S.jpg',
    largeimg: '/images/project-gallery/garage-front-L.jpg',
    heading: "Outdoor Lighting",
    desc: "Outdoor lighting installed for a garage project",
    portrait: false
  },
  {
    id: 2,
    img: '/images/project-gallery/consumer-unit-S.jpg',
    largeimg: '/images/project-gallery/consumer-unit-L.jpg',
    heading: "Consumer Unit",
    desc: "Hager consumer unit installation with RCBO's and SPD",
    portrait: false
  },
  {
    id: 3,
    img: '/images/project-gallery/security-camera-S.jpg',
    largeimg: '/images/project-gallery/security-camera-L.jpg',
    heading: "Security Camera",
    desc: "Outdoor WIFI security camera",
    portrait: false
  },
  {
    id: 4,
    img: '/images/project-gallery/LED-panels-S.jpg',
    largeimg: '/images/project-gallery/LED-panels-L.jpg',
    heading: "LED Panels",
    desc: "300 x 1200 LED panels installed for a garage project",
    portrait: false
  },
  {
    id: 5,
    img: '/images/project-gallery/light-fitting-S.jpg',
    largeimg: '/images/project-gallery/light-fitting-L.jpg',
    heading: "LED Lights",
    desc: "Suspended LED light fitting installed in a kitchen",
    portrait: true
  },
  {
    id: 6,
    img: '/images/project-gallery/ring-doorbell-S.jpg',
    largeimg: '/images/project-gallery/ring-doorbell-L.jpg',
    heading: "Doorbell Installation",
    desc: "Ring video doorbell pro installation",
    portrait: true
  },
  {
    id: 7,
    img: '/images/project-gallery/security-lights-S.jpg',
    largeimg: '/images/project-gallery/security-lights-L.jpg',
    heading: "Outdoor Lighting",
    desc: "Outdoor lighting floodlight installation",
    portrait: false
  },
  {
    id: 8,
    img: '/images/project-gallery/outdoor-socket-S.jpg',
    largeimg: '/images/project-gallery/outdoor-socket-L.jpg',
    heading: "Outdoor Socket",
    desc: "Outdoor weatherproof RCD double socket installation",
    portrait: false
  },
  {
    id: 9,
    img: '/images/project-gallery/outdoor-lighting-S.jpg',
    largeimg: '/images/project-gallery/outdoor-lighting-L.jpg',
    heading: "Outdoor Lighting",
    desc: "Outdoor lighting and power installation for a decking project",
    portrait: true
  },
  {
    id: 10,
    img: '/images/project-gallery/light-pendant-S.jpg',
    largeimg: '/images/project-gallery/light-pendant-L.jpg',
    heading: "Light Installation",
    desc: "LED suspended light fitting installation",
    portrait: true
  },
  {
    id: 11,
    img: '/images/project-gallery/decking-lights-S.jpg',
    largeimg: '/images/project-gallery/decking-lights-L.jpg',
    heading: "Decking Lights",
    desc: "LED post lights installed to light up new decking",
    portrait: false
  },
  {
    id: 12,
    img: '/images/project-gallery/radiator-S.jpg',
    largeimg: '/images/project-gallery/radiator-L.jpg',
    heading: "Electric Radiator",
    desc: "Rointe Kyros electric radiator installation",
    portrait: false
  },
];

export default projects;

